import { checkAxiosData, filterObjProps, getAxiosConfig } from 'fe-common'
import { from, filter, concatMap } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'

/**
 *
 * @param id
 * @param activityUrl
 * @param imgPath1
 * @param imgPath2
 * @param activityUrlType: I: 內部連結, U: 到優惠活動專區, Ｅ: 外部連結, N: 沒有使用連結
 * @param position 為前台顯示的位子順序
 * @param title 為前台顯示的位子名稱
 * @returns {{id: Number, imgPath: *, mobileImgPath: *, type: (boolean|string), url: *}}
 */
const convert = ({
  id,
  activityUrl,
  imgPath1,
  imgPath2,
  activityUrlType,
  position,
  title
}) => ({
  id,
  url: activityUrl,
  imgPath: imgPath1,
  mobileImgPath: imgPath2,
  type:
    (activityUrlType === 'I' && 'INTERNAL_LINK') ||
    (activityUrlType === 'U' && 'PROMOTION') ||
    (activityUrlType === 'E' && 'EXTERNAL_LINK') ||
    (activityUrlType === 'N' && 'NO_USE'),
  positionSerialNum: position,
  title
})

export default {
  state: () => ({
    banners: [],
    authBanners: []
  }),
  actions: {
    getBanners(context, payload = {}) {
      const { rootState, dispatch } = context
      // context.dispatch('updateLoading', true)
      // await delay(3000)
      // context.commit('BANNERS', comp[process.env.COMP_ID].banners)
      // context.dispatch('updateLoading', false)

      return from(dispatch('updateBanners', { type: payload.type }))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/bannerConfig/search/list`,
                {
                  languageCode: rootState.locale,
                  ...filterObjProps(
                    payload,
                    Object.keys(payload).filter(key => key !== 'type')
                  )
                },
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(({ data }) =>
            from(
              dispatch('updateBanners', {
                type: payload.type,
                data: data || []
              })
            )
          )
        )
        .toPromise()
    },
    getIndexBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'H',
        ...payload
      })
    },
    getSlotBanners({ dispatch, commit }, payload = {}) {
      if (['01', '02'].includes(process.env.TEMPLATE_ID)) {
        commit('BANNERS', [
          {
            type: 'NO_USE',
            url: '#',
            imgPath: `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${
              process.env.TEMPLATE_ID
            }/slot-banner-1.jpg`,
            mobileImgPath: `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${
              process.env.TEMPLATE_ID
            }/slot-banner-1.jpg`
          }
        ])
        return Promise.resolve()
      } else {
        return dispatch('getBanners', {
          tag: 'G',
          position: 2,
          ...payload
        })
      }
    },
    getRtpBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'RTP',
        ...payload
      })
    },
    getPromotionBanners({ commit, dispatch }) {
      if (['01', '02'].includes(process.env.TEMPLATE_ID)) {
        commit('BANNERS', [
          {
            type: 'NO_USE',
            url: '#',
            imgPath: `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${
              process.env.TEMPLATE_ID
            }/promotion-banner-1.png`,
            mobileImgPath: `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${
              process.env.TEMPLATE_ID
            }/promotion-banner-1.png`
          }
        ])
        return Promise.resolve()
      } else {
        return dispatch('getBanners', {
          tag: 'P'
        })
      }
    },
    getRecommendedGameBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'G',
        position: 4,
        ...payload
      })
    },
    getRealPersonVideoBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'G',
        position: 1,
        ...payload
      })
    },
    getFishDetailBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'G',
        position: 3,
        ...payload
      })
    },
    getPachinkoBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'G',
        position: 5,
        ...payload
      })
    },
    getUserCenterBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'USER_CENTER'
      })
    },
    getAboutBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'C',
        ...payload
      })
    },
    getTermsBanners({ dispatch }) {
      return dispatch('getAboutBanners')
    },
    getAnnoBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'A'
      })
    },
    getVipBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'V'
      })
    },
    getTutorialBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'T'
      })
    },
    getBeginnerBanners({ dispatch }) {
      return dispatch('getTutorialBanners')
    },
    getHowtoBanners({ dispatch }) {
      return dispatch('getTutorialBanners')
    },
    getFaqBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'F'
      })
    },
    getQaBanners({ dispatch }) {
      return dispatch('getFaqBanners')
    },
    getCasinoBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'N'
      })
    },
    getJackpotBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'J'
      })
    },
    getAgentBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'A'
      })
    },
    getPaymentBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'B'
      })
    },
    getDepositBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'DEPOSIT'
      })
    },
    getCouponBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'COUPON'
      })
    },
    getAuthBanners({ dispatch }, { tag = 'SIGN' } = { tag: 'SIGN' }) {
      return dispatch('getBanners', {
        type: 'AUTH',
        tag
      })
    },
    getSimpleSignUpBanners({ dispatch }) {
      return dispatch('getBanners', {
        type: 'AUTH',
        tag: 'SIGN2'
      })
    },
    getSignUpBanners({ dispatch }) {
      return dispatch('getBanners', {
        type: 'AUTH',
        tag: 'SIGN3'
      })
    },
    getSignUpPageBanners({ dispatch }) {
      return dispatch('getBanners', {
        type: 'AUTH',
        tag: 'SIGN4'
      })
    },
    getFavoriteBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'FAVORITE'
      })
    },
    getWinnersBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'WINNERS'
      })
    },
    getFreeDemoBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'D',
        ...payload
      })
    },
    getRankingBanners({ dispatch }, payload = {}) {
      return dispatch('getBanners', {
        tag: 'RANKING',
        ...payload
      })
    },
    getMaintenanceBanners({ dispatch }) {
      return dispatch('getBanners', {
        tag: 'MAINTENANCE'
      })
    },
    updateBanners({ commit }, { type, data = [] } = { data: [] }) {
      if (type && type === 'AUTH') {
        commit('AUTH_BANNERS', data.map(convert))
      } else {
        commit('BANNERS', data.map(convert))
      }
    }
  },
  mutations: {
    BANNERS(state, payload) {
      state.banners = payload
    },
    AUTH_BANNERS(state, payload) {
      state.authBanners = payload
    }
  },
  getters: {
    banners: state => state.banners,
    authBanners: state => state.authBanners
  }
}
